import * as LoanApplicationActions from '../../../actions/LoanApplicationActions';
import * as WizardActions from '../../../actions/WizardActions';
import * as UIActions from '../../../actions/UIActions';
import {defaultState} from '../../state';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as ValidateConstant from '../../../constants/ValidateConstant';
import {
    ApplicantInfoSummaryDTO,
    EmploymentInfoSummaryDTO,
    FieldApplicantSummary
} from '../../../types/mx/creditoReal/epics';
import {
    PersonalDataTurboCashStepViewFieldErrorState,
    WorkDataTurboCashStepViewErrorFieldState
} from '../../../types/mx/turboCash/reducers';

const workDataStepView = (state = defaultState.turboCash.ui.workDataStepView, action) => {
    switch (action.type) {
        case LoanApplicationActions.CLEAN_LOAN_APPLICATION_DATA_ACTION.name:
            return {
                ...state,
                hasPostalCodeError: false,
            };
        case LoanApplicationActions.ERROR_GOT_LOCATIONS_ACTION.name:
            return {
                ...state,
                hasPostalCodeError: true,
            };
        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_NAME_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    workplaceNameFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_POSITION_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    positionFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_WORKING_SINCE_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    workingSinceFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_ROTATION_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    employmentRotationFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_ADDRESS_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    addressFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_EXT_NUMBER_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    extNumberFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_INT_NUMBER_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    intNumberFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_STREET_BETWEEN_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    streetBetweenFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    workplacePhoneFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    workplacePhoneExtError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_MONTHLY_INCOMES_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    monthlyIncomesFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    postalCodeFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_STATES_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    stateFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_CITY_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    cityFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    municipalityFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_COLONY_MX_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    selectedColonyFieldError: action.error
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_COLONIES_TC_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    selectedColonyFieldError: action.error
                }
            };
        case WizardMXActions.NOT_FOUND_LOCATION_ERROR_MX_ACTION.name:
            return {
                ...state,
                fieldErrors: {
                    ...state.fieldErrors,
                    postalCodeFieldError: ValidateConstant.ERROR_POSTAL_CODE,
                    stateFieldError: ValidateConstant.ERROR_REQUIRED,
                    cityFieldError: ValidateConstant.ERROR_REQUIRED,
                    municipalityFieldError: ValidateConstant.ERROR_REQUIRED,
                    selectedColonyFieldError: ValidateConstant.ERROR_REQUIRED
                }
            };
        case WizardMXActions.SET_EMPLOYMENT_INFO_DATA_STATE_ACTION.name:
            const fieldSummary:
                FieldApplicantSummary<EmploymentInfoSummaryDTO, WorkDataTurboCashStepViewErrorFieldState>
                = action.employmentInfo;
            return {
                ...state,
                fieldErrors: fieldSummary.fieldErrors
            };
        case UIActions.CLEAN_STATE_ACTION.name:
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.name:
            return defaultState.turboCash.ui.workDataStepView;
        default:
            return state;
    }
};

export default workDataStepView;